import script from "./userLevelTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./userLevelTwo.vue?vue&type=script&setup=true&lang=js"

import "./userLevelTwo.vue?vue&type=style&index=0&id=79613ffe&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79613ffe"]])

export default __exports__